import React from "react";
import { Container } from "semantic-ui-react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { source } from 'react-aim';
import TeamsListView from '../drive/TeamsView/TeamsListView';
import TeamsGridView from '../drive/TeamsView/TeamsGridView';
import BreadCrumbOrganization from "../drive/cards/BreadCrumbOrganization";
@source({
  mouseEnter: (props, component) => {
    dispatch.app.setHelpContext(props.name);
  }
})

class OrganizationList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  componentWillMount() {
    dispatch.organizationUnit.showDeleteDisabled(false)
  }

  render() {
    return (
      <Container fluid >
        <BreadCrumbOrganization {...this.props} />
        {this.props.teamsListViewFlag ?
          <TeamsListView subOrgs={this.props.subOrgs} {...this.props} />
          : <TeamsGridView subOrgs={this.props.subOrgs} {...this.props} />
        }

      </Container>
    );
  }
}


export default withRouter(OrganizationList)

